import { Box, Button, Typography } from '@mui/material';
import { openNewTab } from './config/FunctionHelper';
import { pluginInstallTrackEvent } from './Analytics';
import { chromeExtensionLink } from './config/TextMessage';
import { newCommonChromeExtensionModalSx } from 'src/content/individualScans/individualSxs';
import { UpgradePlanLiteModalSxs } from 'src/content/keywordResearch/keywordResearchCSS';

const NotChromeBrowswerBanner = () => {
  return (
    <>
      <Box sx={newCommonChromeExtensionModalSx?.mainBox}>
        <Box>
          <Box sx={UpgradePlanLiteModalSxs?.headerBox}>
            <img
              style={UpgradePlanLiteModalSxs?.img}
              src={
                process.env.PUBLIC_URL + `/static/images/icons/ChromeLogo.svg`
              }
              alt="icon"
            />
            <Box>
              <Typography sx={newCommonChromeExtensionModalSx?.headerText}>
                Use Supported Browser for Full Access
              </Typography>
              <Typography sx={newCommonChromeExtensionModalSx?.desc}>
                Please switch to a supported browser such as{' '}
                <b>Chrome, Microsoft Edge</b> or <b>Firefox</b> to install
                SEOSpace's Chrome Extension and make the most out of our
                platform.
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Box sx={{ flex: 1 }} /> {/* Spacer */}
          <Button
            variant="contained"
            className="download-chrome-plugin"
            sx={{
              width: 'auto',
              height: 10,
              fontFamily: 'PoppinsThin',
              py: 2.5,
              borderRadius: 0.6,
              marginRight: '5px',
              backgroundColor: 'var(--color-secondary)',
              whiteSpace: 'nowrap',
              flexShrink: 0, // Prevent button from shrinking
              '&:hover': {
                backgroundColor: 'var(--color-secondary)'
              }
            }}
            onClick={() => {
              // Function to open a new tab with the Chrome extension download link
              pluginInstallTrackEvent();
              openNewTab(chromeExtensionLink);
            }}
          >
            <Typography sx={{ color: 'var(--color-primary)', fontWeight: 400 }}>
              Chrome Web Store
            </Typography>
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default NotChromeBrowswerBanner;
